import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SupportiveMaterialsState {
  /**
   * Organization IDs for which the user explicitly chose to hide the
   * supportive-materials prompt ("Hide this, I'll do this later in
   * Settings > Knowledge"). Persisted on the device so the prompt never
   * reappears for that organization on this browser.
   */
  hiddenOrganizationIds: string[];
  hide: (organizationId: string) => void;
}

export const useSupportiveMaterialsStore = create<SupportiveMaterialsState>()(
  persist(
    (set) => ({
      hiddenOrganizationIds: [],
      hide: (organizationId: string) =>
        set((state) =>
          state.hiddenOrganizationIds.includes(organizationId)
            ? state
            : {
                hiddenOrganizationIds: [
                  ...state.hiddenOrganizationIds,
                  organizationId,
                ],
              }
        ),
    }),
    {
      name: "sky-supportive-materials",
      partialize: (state) => ({
        hiddenOrganizationIds: state.hiddenOrganizationIds,
      }),
    }
  )
);
